import { ZodString } from "zod";

export function requiredZodString(schema: ZodString, required: boolean) {
  return required ? schema.min(1, { message: "Required" }) : schema;
}
